(function(wndw) {
  var jadify = function(jade, _t, _h) {
    var yudify = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (_t) {
buf.push("<div tabindex=\"0\" aria-label=\"Autoplay\" class=\"c-autoplay-menu-section\"><div class=\"vjs-menu-title\"><h3 class=\"menu-section-title headline-1-text\">" + (jade.escape((jade_interp = _t("Autoplay")) == null ? '' : jade_interp)) + "</h3></div><div class=\"c-menu-divider\"></div><div class=\"c-autoplay-button-container\"><button data-js=\"autoplay-off-button\" aria-label=\"Autoplay Off\" class=\"c-autoplay-button c-autoplay-off-button\">" + (jade.escape((jade_interp = _t("Off")) == null ? '' : jade_interp)) + "</button><button data-js=\"autoplay-on-button\" aria-label=\"Autoplay On\" class=\"c-autoplay-button c-autoplay-on-button\">" + (jade.escape((jade_interp = _t("On")) == null ? '' : jade_interp)) + "</button></div></div>");}.call(this,"_t" in locals_for_with?locals_for_with._t:typeof _t!=="undefined"?_t:undefined));;return buf.join("");
};
    return function(locals) {
      if (locals) {
        if ("_t" in locals) { _t = locals._t.merge(_t); }
        // Jade helper objects must define this merge method.
      }
      return yudify(locals);
    };
  };
  if(typeof define === "function" && define.amd) {
    define([
      "js/vendor/jade"
      ,"i18n!bundles/videojs/layout/nls/autoplayMenuSection"
    ], function(
      jade
      ,_t
    ) {
      var _h;
      return jadify(jade, _t, _h);
    });
  } else {
    wndw.jade.templates["bundles.videojs.layout.autoplayMenuSection"] = jadify(wndw.jade.helpers);
  }
})(window);
